import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchList, fetchDelete } from "@/api/PMS/performancecenter/theaterManageDetail";
import waves from '@/directive/waves'; // 水波纹指令

import addConfig from './addConfig.vue';
import priceList from './priceList.vue';
import seat from './seat.vue';
export default {
  name: 'ComplexTable',
  components: {
    addConfig: addConfig,
    priceList: priceList,
    seat: seat
  },
  props: ['keyValue', 'showDialog', 'activityAuditStatus'],
  directives: {
    waves: waves
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.listQuery = {
          page: 1,
          limit: 10,
          activityManageId: ''
        };
        this.getList();
      }
    }
  },
  data: function data() {
    return {
      list: null,
      total: null,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 10,
        activityManageId: ''
      },
      title: '',
      Id: -1,
      theaterId: '',
      multipleSelection: [],
      dialogPriceVisible: false,
      dialogFormVisible: false,
      dialogSeatVisible: false
    };
  },
  computed: {
    showEdit: function showEdit() {
      if (this.activityAuditStatus == 0) {
        return true;
      }

      return false;
    }
  },
  created: function created() {
    this.getList();
  },
  methods: {
    handCancle: function handCancle(reload) {
      if (reload) {
        this.getList();
      }

      this.dialogFormVisible = false;
      this.dialogPriceVisible = false;
      this.dialogSeatVisible = false;
    },
    getList: function getList() {
      var _this = this;

      this.listLoading = true;
      this.$set(this.listQuery, "activityManageId", this.keyValue);
      fetchList(this.listQuery).then(function (response) {
        _this.list = response.data.data;
        _this.total = response.data.total;
        _this.listLoading = false;
      });
    },
    // handleFilter () {
    //   this.listQuery.page = 1
    //   this.getList()
    // },
    handleSizeChange: function handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 创建
    handleCreate: function handleCreate() {
      this.Id = -1;
      this.title = '添加';
      this.dialogFormVisible = true;
    },
    handleSetPrcie: function handleSetPrcie(_ref) {
      var id = _ref.id,
          theaterId = _ref.theaterId;
      this.Id = id;
      this.theaterId = theaterId;
      this.title = '区域价格设置';
      this.dialogPriceVisible = true;
    },
    handleSeat: function handleSeat(_ref2) {
      var id = _ref2.id,
          theaterId = _ref2.theaterId;
      this.Id = id;
      this.theaterId = theaterId;
      this.title = '座位设置';
      this.dialogSeatVisible = true;
    },
    // 编辑
    handleUpdate: function handleUpdate(Id) {
      this.Id = Id;
      this.title = '编辑';
      this.dialogFormVisible = true;
    },
    delete: function _delete(Ids) {
      var _this2 = this;

      if (Ids.length > 0) {
        this.$confirm('你确定是要删除这些记录, 是否继续?', '提示').then(function () {
          fetchDelete({
            ids: Ids
          }).then(function (response) {
            if (response.data.code === 200) {
              _this2.getList();

              _this2.Alert({
                alertType: 'delete'
              });
            }
          });
        });
      } else {
        this.Alert({
          alertType: 'nodata'
        });
      }
    },
    handleDelete: function handleDelete(Id) {
      var Ids = [];
      Ids.push(Id);
      this.delete(Ids);
    },
    handleDeletes: function handleDeletes() {
      var Ids = [];
      this.multipleSelection.forEach(function (row) {
        Ids.push(row.id);
      });
      this.delete(Ids);
    }
  }
};